var ignoredStatuses = [401, 406];
export var buildErrorMessage = function (error) {
    if (ignoredStatuses.includes(error.status)) {
        return null;
    }
    if (error.status === 422) {
        var errors = [];
        var message = error.message;
        try {
            var parsedMessage = JSON.parse(error.message);
            var nestedMessage = parsedMessage[0].message;
            if (nestedMessage) {
                message = nestedMessage;
                var prefix = "\"".concat(parsedMessage[0].key, "\"");
                if (!nestedMessage.startsWith(prefix)) {
                    message = "".concat(prefix, " ").concat(nestedMessage);
                }
            }
        }
        catch (err) {
            /* not a JSON string */
        }
        // Handle json schema errors
        if (Array.isArray(error.errors) && error.errors.length && error.errors[0].fieldName !== undefined) {
            errors = error.errors.filter(function (err) { return err.fieldName; }).map(function (err) { return "".concat(err.fieldName, " ").concat(err.message); });
        }
        return {
            errors: errors,
            message: message,
        };
    }
    return {
        message: error.message,
    };
};
